export default __webpack_public_path__ + "static/media/ic-logout2.dc698d91.svg";